import animation from '@helpers/animation';
import { useInView } from '@hooks/useInView';
import LinkButton from '@stories/Components/Buttons/LinkButton/LinkButton';
import React from 'react';
import S from './RichText.styles';
const RichText = ({ id, content, cta, leadParagraph = false }) => {
    const [refContainer, isInView] = useInView({
        rootMargin: animation.inView.rootMargin,
    });
    return (React.createElement(S.Container, { ref: refContainer, id: id, isActive: isInView, innerWidth: "narrow" },
        React.createElement(S.Content, { dangerouslySetInnerHTML: { __html: content }, leadParagraph: leadParagraph }),
        cta?.text && (React.createElement(LinkButton, { href: cta.url, target: cta.target, themeOption: "blackOutline", title: cta.text, "aria-label": cta.accessibleText }))));
};
export default RichText;
